import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

export interface ComplaintTypeModel {
  id?: number;
  description: string;
  createdAt?: string;  // LocalDateTime -> string no formato ISO (YYYY-MM-DDTHH:mm:ss)
  updatedAt?: string;  // LocalDateTime -> string ISO
  deletedAt?: string;  // LocalDateTime -> string ISO (para soft delete)
}

// Interface auxiliar para soft delete (opcional, se precisar em outras partes)
export interface SoftDeleteable {
  softDelete(): void;
  restore(): void;
}

@Injectable({
  providedIn: 'root'
})
export class ComplaintTypeService {

  private readonly baseUrl = `${environment.apiUrl}/nucon/api/v1/complaint-type`;

  private readonly httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json'
    })
  };

  constructor(private http: HttpClient) {}

  findAll(): Observable<ComplaintTypeModel[]> {
    return this.http.get<ComplaintTypeModel[]>(`${this.baseUrl}/all`, this.httpOptions);
  }

  findById(id: number): Observable<ComplaintTypeModel> {
    return this.http.get<ComplaintTypeModel>(`${this.baseUrl}/${id}`, this.httpOptions);
  }

  save(complaintType: ComplaintTypeModel): Observable<ComplaintTypeModel> {
    return this.http.post<ComplaintTypeModel>(this.baseUrl, complaintType, this.httpOptions);
  }

  update(id: number, complaintType: ComplaintTypeModel): Observable<ComplaintTypeModel> {
    return this.http.put<ComplaintTypeModel>(`${this.baseUrl}/${id}`, complaintType, this.httpOptions);
  }

  deleteById(id: number): Observable<void> {
    return this.http.delete<void>(`${this.baseUrl}/${id}`, this.httpOptions);
  }

  /**
   * DELETE /{id} — Soft delete (exclui logicamente, marca deletedAt).
   * O controller Java chama complaintTypeService.softDeleteById(id).
   */
  softDeleteById(id: number): Observable<void> {
    return this.http.delete<void>(`${this.baseUrl}/${id}`, this.httpOptions);
  }
}
